import React from "react";
import { View } from "react-native";

import { useDevSession } from "../../dev/devSession";
import { Btn, Note, Row, Toggle } from "./controls";

/** View-only toggles: reduced motion, FPS, hover debug. */
const ViewSection: React.FC = () => {
  const reduced = useDevSession((s) => s.forceReducedMotion);
  const showFps = useDevSession((s) => s.showFps);
  const hoverDebug = useDevSession((s) => s.hoverDebug);
  const set = useDevSession.getState().set;
  const opts: { label: string; value: boolean | null }[] = [
    { label: "OS", value: null },
    { label: "on", value: true },
    { label: "off", value: false },
  ];
  return (
    <View>
      <Row wrap>
        <Note>Reduced motion</Note>
        {opts.map((o) => (
          <Btn
            key={o.label}
            testID={`dev-reduced-${o.label}`}
            label={o.label}
            on={reduced === o.value}
            onPress={() => set({ forceReducedMotion: o.value })}
          />
        ))}
      </Row>
      <Toggle
        testID="dev-fps"
        label="FPS / frame time"
        value={showFps}
        onChange={(v) => set({ showFps: v })}
      />
      <Toggle
        testID="dev-hover-debug"
        label="Hover debug (word, in-degree, edge similarity)"
        value={hoverDebug}
        onChange={(v) => set({ hoverDebug: v })}
      />
    </View>
  );
};

export default ViewSection;
